import React, { useState, useEffect, useRef } from 'react';
import { config } from 'utils/config';
import { callApi, showSweetAlert } from 'utils/utils';
import FieldButton from 'components/Controls/FieldButton/FieldButton.jsx';
import { Card, CardBody } from 'reactstrap';

const DMINDLogin = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDMIND();
  }, []);

  const loadDMIND = async () => {
    setIsLoading(true);
    const urlWebService = `${config.UrlApiProject}DMIND/DMINDAuthentication`;
    const paramsService = {};

    callApi(urlWebService, 'GET', paramsService, (response) => {
      const {loginPath} = response.data;
      const redirectUrl = `https://d-mind.deacerousa.ai${loginPath}&redirectTo=/workspace/sap-assistant`;
      window.location.href = redirectUrl;
      setIsLoading(false);
    });
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      {!isLoading && (
        <Card>
          <CardBody className="text-center">
            <h3>Please wait while we launch D-MIND...</h3>
            <p>If you are not redirected automatically, click the button below.</p>
            <FieldButton
              label="Launch D-MIND"
              onClick={() => loadDMIND()}
            />
          </CardBody>
        </Card>
      )}
    </div>
  );
};

export default DMINDLogin;